module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Chapter01#ch-1"
    }
  }, [_vm._v("1. Boots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Wormwood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Pravda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Zones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Vultures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Something Odd Going On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Chernobyl AIDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Merry Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Minister and Morgue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Pripyat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Pioneers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Happy New Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Not to Worry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Author as Swine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Prohibited Zone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. No Exit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Epilog#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Epilog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo section")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8f4adb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0